export default {
    props: {
        value: String
    },
    computed: {
        internalValue: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        },
        year: {
            get () {
                return Number(this.value.split('-')[0])
            },
            set (val) {
                this.$emit('input', this.getValue(val, this.month))
            }
        },
        month: {
            get () {
                return Number(this.value.split('-')[1])
            },
            set (val) {
                this.$emit('input', this.getValue(this.year, val))
            }
        }

    },
    methods: {
        getValue (year, month) {
            return `${year.toString().padStart(4, '0')}-${month.toString().padStart(2, '0')}`
        },
        goToNextMonth () {
            let year = this.year
            let month = this.month
            if (++month > 12) {
                year++
                month = 1
            }
            this.internalValue = this.getValue(year, month)
        },
        goToPrevMonth () {
            let year = this.year
            let month = this.month
            if (--month < 1) {
                year--
                month = 12
            }
            this.internalValue = this.getValue(year, month)
        }
    }
}
